/* kh-produkt.js — Menge, Staffelstufe, Summe und Variantenwechsel.
   Preise stehen als data-Attribute am Kaufkasten (kh-staffel-daten). */
/* Start erst, wenn window.KH da ist: dieses Skript steht in der Sektion,
   kh-warenkorb.js (definiert KH) erst am Ende von theme.liquid. Beide sind
   defer und laufen in Dokumentreihenfolge -- dieses also zuerst. Vorher brach
   es mit !window.KH still ab: Summe, aktive Stufe und Variantenwechsel
   blieben stehen (gemessen 23.09.2026 auf dem Dev-Server). Vor
   DOMContentLoaded sind alle defer-Skripte gelaufen. */
(function () {
  'use strict';
  if (!window.KH) { document.addEventListener('DOMContentLoaded', start); return; }
  start();
  function start() {
  var wurzel = document.querySelector('[data-kh-produkt]');
  var kauf = wurzel && wurzel.querySelector('[data-kh-kauf]');
  if (!kauf || !window.KH) return;

  var kette = kauf.dataset.staffel;
  var hatStaffel = kauf.dataset.hatStaffel === 'true';
  var mengeInput = kauf.querySelector('[data-kh-menge]');
  var summe = kauf.querySelector('[data-kh-summe]');
  var summeSub = kauf.querySelector('[data-kh-summe-sub]');
  var zeilen = kauf.querySelectorAll('[data-kh-staffel-tabelle] tr[data-ab]');
  var addKnopf = kauf.querySelector('[data-kh-add]');
  var addText = kauf.querySelector('[data-kh-add-text]');
  var status = kauf.querySelector('[data-kh-status]');
  var preisAb = kauf.querySelector('[data-kh-preis-ab]');
  var basis = parseInt(kauf.dataset.basis, 10) || 0;
  /* Einzeldosen (data-welt="einzel") zeigen brutto: Variantenpreis netto
     mal MwSt.-Faktor aus data-mwst (kh-preis-einzel). Haendlerpreise
     bleiben netto, Faktor 1. */
  var mwst = parseFloat(kauf.dataset.mwst) || 1;
  function anzeige(cent) { return Math.round(cent * mwst); }

  function rechnen() {
    if (!mengeInput) return;
    var menge = parseInt(mengeInput.value, 10) || 0;
    var preis = hatStaffel ? KH.staffelPreis(kette, menge) : basis;
    if (summe) summe.textContent = KH.geld(anzeige(preis * menge));
    if (summeSub) summeSub.textContent = KH.zahl(menge) + ' Stk × ' + KH.geld(anzeige(preis)) + (hatStaffel ? ' · netto' : '');
    var aktiv = -1;
    zeilen.forEach(function (z, i) { if (menge >= parseInt(z.dataset.ab, 10)) aktiv = i; });
    zeilen.forEach(function (z, i) { z.setAttribute('aria-current', i === aktiv ? 'true' : 'false'); });
  }

  kauf.addEventListener('kh:menge', rechnen);
  if (mengeInput) mengeInput.addEventListener('input', rechnen);

  kauf.querySelectorAll('[data-kh-schnell]').forEach(function (k) {
    k.addEventListener('click', function () {
      if (!mengeInput) return;
      mengeInput.value = k.dataset.khSchnell;
      mengeInput.dispatchEvent(new Event('change', { bubbles: true }));
      rechnen();
    });
  });

  /* Varianten */
  var varianten = kauf.querySelectorAll('[data-kh-variante]');
  varianten.forEach(function (v) {
    v.addEventListener('click', function () {
      varianten.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      v.setAttribute('aria-pressed', 'true');
      if (!hatStaffel) { basis = parseInt(v.dataset.preis, 10) || basis; if (preisAb) preisAb.textContent = KH.geld(anzeige(basis)); }
      var da = v.dataset.verfuegbar === 'true';
      var lager = parseInt(v.dataset.lager, 10) || 0;
      if (status) {
        status.className = 'kh-status kh-status--' + (da && lager > 0 ? 'ok' : da ? 'nachbestellbar' : 'aus');
        status.textContent = da && lager > 0 ? 'Auf Lager' : da ? 'Nachbestellbar' : 'Ausverkauft';
      }
      if (addKnopf) { addKnopf.disabled = !da; addKnopf.dataset.variant = v.dataset.khVariante; }
      if (addText) addText.textContent = da ? 'In den Warenkorb' : 'Nicht verfügbar';
      var sku = wurzel.querySelector('[data-kh-sku]'), ean = wurzel.querySelector('[data-kh-ean]');
      if (sku) sku.innerHTML = v.dataset.sku ? 'Art.-Nr. <b>' + v.dataset.sku + '</b>' : '';
      if (ean) ean.innerHTML = v.dataset.ean ? 'EAN <b>' + v.dataset.ean + '</b>' : '';
      var skuZ = wurzel.querySelector('[data-kh-sku-zelle]'), eanZ = wurzel.querySelector('[data-kh-ean-zelle]');
      if (skuZ) skuZ.textContent = v.dataset.sku || '–';
      if (eanZ) eanZ.textContent = v.dataset.ean || '–';
      var bild = wurzel.querySelector('[data-kh-hauptbild]');
      if (bild && v.dataset.bild) { bild.src = v.dataset.bild; bild.removeAttribute('srcset'); }
      var url = new URL(location.href); url.searchParams.set('variant', v.dataset.khVariante); history.replaceState(null, '', url);
      rechnen();
    });
  });

  /* Galerie */
  wurzel.querySelectorAll('[data-kh-mini]').forEach(function (m) {
    m.addEventListener('click', function () {
      var bild = wurzel.querySelector('[data-kh-hauptbild]');
      if (!bild) return;
      bild.src = m.dataset.khMini; bild.removeAttribute('srcset');
      wurzel.querySelectorAll('[data-kh-mini]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
      m.setAttribute('aria-current', 'true');
    });
  });

  rechnen();
  }
})();
